import styled from "styled-components";
import { COLORS } from "../../../constants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  //align-items: center;
  gap: 20px;
  padding: 20px;
  padding-bottom: 120px;
  //max-width: 900px;
  //margin: auto;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 20px;
  padding: 20px;
  padding-bottom: 160px;
`;

const Card = styled.div`
  display: flex;
  //padding: 20px;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 20px;
  background: ${COLORS.WHITE};
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 6px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CardFonction = styled.p`
  color: ${COLORS.DARK};
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

const LabelName = styled.h3`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  overflow-wrap: anywhere;
`;

const LabelDate = styled.p`
  color: ${COLORS.DARK};
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

const ArrowContainer = styled.div`
  display: flex;
  width: 35px;
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 0px 20px 20px 0px;
  background: ${COLORS.PRIMARY};
`;
export {
  Container,
  CardContainer,
  Card,
  CardHeader,
  CardFonction,
  LabelName,
  LabelDate,
  ArrowContainer,
}